module.exports = __webpack_public_path__ + "static/img/user.54a04098.svg";